import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ComponentLoader from '@gef-ui/components/molecules/ComponentLoader';
import { getUserLogon } from '@gef-ui/redux-common/selectors/appContext';
import { continueToApplication } from '../../actions';
import { setOriginalUserCookies } from '../../utils';
import CenteredButton from '../CenteredButton';
import ChooseDelegation, { delegationsShape } from '../ChooseDelegation';
import { useDefaultDelegationsValue } from '../utils';
const COMPONENT_NAME = 'DelegationTab';
const DelegationTab = (inProps)=>{
    const props = useDefaultDelegationsValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { delegations, userFullName, allowedCompany, continueAction, selectors, userInfoEndpointCreators, Wrapper = React.Fragment } = props;
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const userLogin = useSelector(getUserLogon);
    const handleClick = useCallback(()=>{
        setLoading(true);
        setOriginalUserCookies(userLogin);
        dispatch(continueToApplication(userLogin, {
            continueAction,
            ...selectors,
            ...userInfoEndpointCreators
        }));
    }, [
        userLogin,
        continueAction,
        selectors,
        dispatch,
        userInfoEndpointCreators
    ]);
    return /*#__PURE__*/ React.createElement(Wrapper, {}, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h1", {
        className: "Delegations-user Text Text--primary Text--mainTitle"
    }, userFullName), allowedCompany && /*#__PURE__*/ React.createElement(ComponentLoader, {
        isLoading: loading
    }, /*#__PURE__*/ React.createElement(CenteredButton, {
        onClick: handleClick,
        label: "delegations:enter"
    })), /*#__PURE__*/ React.createElement(ChooseDelegation, {
        delegations: delegations,
        allowedCompany: allowedCompany,
        continueAction: continueAction,
        userInfoEndpointCreators: userInfoEndpointCreators,
        selectors: selectors
    })));
};
DelegationTab.propTypes = {
    Wrapper: PropTypes.any,
    allowedCompany: PropTypes.bool,
    company: PropTypes.string,
    continueAction: PropTypes.func,
    delegations: delegationsShape,
    selectors: PropTypes.shape({
        getIsLogoutFetchLoaded: PropTypes.func,
        getIsOriginalUserFetchLoaded: PropTypes.func
    }),
    userFullName: PropTypes.string,
    userInfoEndpointCreators: PropTypes.shape({
        createFetchAction: PropTypes.func,
        createFetchActionWithRepresentedUser: PropTypes.func
    })
};
export default DelegationTab;
